import { render } from "./IconBandwidth.vue?vue&type=template&id=179b4a12"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconBandwidth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "179b4a12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('179b4a12', __exports__)) {
    api.reload('179b4a12', __exports__)
  }
  
  module.hot.accept("./IconBandwidth.vue?vue&type=template&id=179b4a12", () => {
    api.rerender('179b4a12', render)
  })

}


export default __exports__